<template>
  <footer>
    <StepIndicator :steps="steps" :current-step="currentStep" class="mb-3" />

    <ContributionModalActions
      :step-count="stepCount"
      :current-step="currentStep"
      :is-message-invalid="isMessageInvalid"
      :is-knowledge-invalid="isKnowledgeInvalid"
      :is-role-ids-invalid="isRoleIdsInvalid"
      @close="sendCloseEvent"
      @go-to-previous-step="sendGoToPreviousStepEvent"
      @go-to-next-step="sendGoToNextStep"
      @send-contribution="sendContributionEvent"
    />
  </footer>
</template>

<script>
import StepIndicator from '@/components/Modals/CreateProductNotificationModal/StepIndicator.vue';
import ContributionModalActions from './ContributionModalActions';

export default {
  name: 'modal-footer',
  components: {
    StepIndicator,
    ContributionModalActions,
  },
  props: {
    steps: Array,
    currentStep: Number,
    stepCount: Number,
    isMessageInvalid: Boolean,
    isKnowledgeInvalid: Boolean,
    isRoleIdsInvalid: Boolean,
  },
  methods: {
    sendCloseEvent() {
      this.$emit('close');
    },
    sendGoToPreviousStepEvent() {
      this.$emit('go-to-previous-step');
    },
    sendGoToNextStep() {
      this.$emit('go-to-next-step');
    },
    sendContributionEvent() {
      this.$emit('send-contribution');
    },
  },
};
</script>
